import _ from 'lodash';
import I18n from '../i18n/I18n'

/**
 * get localized string
 */
export const getLocalizedData = localizedDatas => {
  localizedDatas = localizedDatas || []

  // get asked locale
  let localizedData = _.find(localizedDatas, data =>
    data.locale.indexOf(I18n.getCurrentLanguageWithoutRegionCode()) > -1
  )

  // no translation found, try default locale
  if (_.isEmpty(localizedData)) {
    localizedData = _.find(localizedDatas, data =>
      data.locale.indexOf(I18n.defaultLocale) > -1
    )
  }

  // no translation found, get the first available
  if (_.isEmpty(localizedData)) {
    localizedData = localizedDatas[0]
  }

  return localizedData && localizedData.text
}
